var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOpenInNewLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19640)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16.7C10 14.0925 12.0925 12 14.7 12H24.1V14.2H14.7C13.3075 14.2 12.2 15.3075 12.2 16.7V33.5C12.2 34.8925 13.3075 36 14.7 36H31.5C32.8925 36 34 34.8925 34 33.5V24.1H36.2V33.5C36.2 36.1075 34.1075 38.2 31.5 38.2H14.7C12.0925 38.2 10 36.1075 10 33.5V16.7Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4778 12.2778L26.1778 23.5778L24.6222 22.0222L35.9222 10.7222L37.4778 12.2778Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8726 10.0003C35.8817 10.0001 35.8909 10 35.9001 10C37.2076 10 38.2001 10.9925 38.2001 12.3C38.2001 12.3092 38.1999 12.3183 38.1997 12.3275L37.9997 20.3275L35.8004 20.2725L35.9999 12.2909C35.999 12.2533 35.9923 12.2322 35.9889 12.2238C35.987 12.219 35.9854 12.2164 35.9847 12.2153C35.9836 12.2146 35.9811 12.2131 35.9762 12.2111C35.9678 12.2078 35.9467 12.2011 35.9092 12.2001L27.9275 12.3997L27.8726 10.2003L35.8726 10.0003Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.2,
    height: 28.2,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpenInNewLight);
export default __webpack_public_path__ + "static/media/icon_open_in_new_light.0e9b779d.svg";
export { ForwardRef as ReactComponent };